<template>
    <div id="my-question-card">
        <div class="card-item" v-for="(item,index) in dataList" :key="index">
            <h2 v-text="item.title"></h2>
            <!-- <span class="creator">创建人：{{item.creator}}</span> -->
            <span class="create-time">創建時間：{{item.createdTime}}</span>
            <a href="javascript:;" class="complted-count" @click="()=>showLastWrongQuestion(item)">查看最近一次的錯題</a>
            <a href="javascript:;" class="complted-count" @click="()=>handleHiddenQuestions(item)">查看不再顯示的問題</a>
            <div class="operation">
                <div class="btn-review" @click="()=>startReview(item)">開始複習</div>
                <div class="schedule">
                    <div :class="{'v-schedule': true, 'full': item.completed/item.total == 1}" :style="{'width': `${Math.round(100 * item.completed/item.total)}%`}"></div>
                    <span>進度：{{`${item.completed}/${item.total}`}}</span>
                </div>
                <a href="javascript:;" class="complted-count" @click="()=>showHistory(item)">已完成{{ item.completedTimes }}次答题</a>
            </div>
        </div>
        <a-modal
            :title="modalTitle"
            :width="800"
            :height="600"
            :centered="true"
            style="z-index: 10000;"
            :visible="showQuestionModal"
            :maskClosable="false"
            @cancel="onQuestionModalCancel"
        >
            <template slot="footer">
                <div class="footer-items">
                    <div class="footer-item switch" @click="switchShowAnswer">
                        <span :class="{ 'icon': true, 'off': !switchOn}"></span>
                        <span>{{switchOn ? '顯示答案' : '關閉顯示答案' }}</span>
                    </div>
                    <a v-if="!isShowWrongQuestion" href="javascript:;" class="footer-item" @click="hideQuestion">不再顯示這題</a>
                </div>

                <a-button :disabled="questionIndex == 0" @click="toPrev">上一题</a-button>
                <a-button :disabled="questionIndex == questionList.length - 1 && isShowWrongQuestion" @click="toNext">{{ (questionIndex == questionList.length - 1 && !isShowWrongQuestion) ? '完成' : '下一題'}}</a-button>
            </template>
            <div class="question-container" v-if="showQuestionModal">
                <dl class="question-item" v-if="questionList[questionIndex].type != 3">
                    <dt class="question-title" v-text="`第${allItemList.findIndex((v)=>questionList[questionIndex].questionBankItemId == v.questionBankItemId) + 1}題: ${questionList[questionIndex].title}`"></dt>
                    <a-radio-group 
                        v-model="questionList[questionIndex].answers" 
                        @change="(e)=>onAnswerChanged(e.target.value)"
                        v-if="questionList[questionIndex].isMultipleChoice != true"
                    >
                        <a-radio :value="answerList[i]" v-for="(label,i) in questionList[questionIndex]['titleItems']" :key="i">
                            {{ label }}
                        </a-radio>
                    </a-radio-group>
                    <a-checkbox-group
                        v-if="questionList[questionIndex].isMultipleChoice == true"
                        v-model="questionList[questionIndex].answers"
                        name="checkboxgroup"
                        :options="questionList[questionIndex]['titleItems'].map((label, i)=>{return ({label: label, value: answerList[i] })})"
                        @change="onAnswerChanged"
                    />
                    <input type="text" class="question-input-answer" placeholder="請輸入答案" v-model="questionList[questionIndex].answers" @input="(e)=>onAnswerChanged(e.target.value)" v-if="questionList[questionIndex].type != 1">
                </dl>
                <div class="question-item" v-if="questionList[questionIndex].type == 3">
                    <div class="question-title">
                        <span v-text="`第${allItemList.findIndex((v)=>questionList[questionIndex].questionBankItemId == v.questionBankItemId) + 1}題：「填空題」`"></span>
                        <div class="question-title-item" v-for="(q,i) in mulQuestions(questionIndex)" :key="i">
                            <span v-text="q"></span>
                            <div class="input-container" v-if="q">
                                <input type="text" placeholder="請輸入答案" @input="onMulAnswerChange($event, questionIndex, i+1)" :value="mulAnswer[`${questionIndex}`][`${i+1}`]">
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div class="right-answer" v-if="switchOn">
                    正確答案：{{rightAnswerMap[mQuestionBankId][questionList[questionIndex].questionBankItemId]}}
                </div>
            </div>
        </a-modal>
        <a-modal
            title="查看不再顯示的問題"
            :width="800"
            :height="200"
            style="z-index: 10000;"
            :visible="hiddenQuestionVisible"
            :maskClosable="false"
            :footer="null"
            @cancel="hiddenQuestionVisible = false"
        >
            <div class="hide-question-list">
                <div class="hide-question-item" v-for="(item,i) in foreverIgnoreItemList" :key="i">
                    <div class="title" v-text="`第${allItemList.findIndex((v)=>item.questionBankItemId == v.questionBankItemId) + 1}題: ${item.title}`"></div>
                    <div class="btn-delete" @click="recoverMark(i)">移除</div>
                </div>
                <span class="empty" v-if="foreverIgnoreItemList.length == 0">暫無數據</span>
            </div>
        </a-modal>

        <a-modal
            title="答題記錄"
            :width="800"
            :height="600"
            :centered="true"
            style="z-index: 10000;"
            :visible="isShowHistory"
            :maskClosable="false"
            :footer="null"
            @cancel="isShowHistory = false"
        >
             <div class="history-list">
                <div class="title">
                    <span class="hint">題庫：</span>
                    <span class="value">問題一</span>
                </div>
                <div class="history-item" v-for="(item,index) in this.historyList" :key="index">
                    <div class="time">
                        <span class="hint">答題開始時間：</span>
                        <span class="value start">{{ moment(item.firstTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                    </div>
                    <div class="time">
                        <span class="hint">答題結束時間：</span>
                        <span class="value end">{{ moment(item.completedTime).format('YYYY-MM-DD HH:mm:ss') }}</span>
                    </div>
                    <div class="desc">
                        <span class="wrong-count">錯誤{{ item.incorrectQuantity }}題{{ item.incorrectQuantity > 0 ? '：' : ''}}</span>
                        <span class="wrong-item" v-for="(d,i) in item.incorrectItemList" :key="i">第{{ allQuestionList.findIndex((v)=>v.questionBankItemId == d.questionBankItemId) + 1}}題</span>
                    </div>
                    <div class="btn-wrong" v-if="item.incorrectQuantity > 0" @click="showWrongQuestion(item)">查看錯題</div>
                </div>
             </div>
        </a-modal>
        <loading v-if="loading"/>
    </div>
</template>
<script>
import Loading from '../Loading.vue';
import moment from 'moment'
export default {
    components: {
        Loading
    },
    data() {
        return {
            answerList: ['A','B','C','D','E','F','G'],
            dataList: [],
            modalTitle: '複習',
            loading: true,
            showQuestionModal: false,
            showAnserResultModal: true,
            userInfo: this.$store.getters.userInfo,
            questionIndex: 0,
            errorCount: 2,
            rightCount: 3,
            maxQuestionCount: 5,
            isShowWrongQuestion: false,
            switchOn: false,

            isShowHistory: false,
            allQuestionList: [],

            finalQuestionList: [],
            questionList: [],

            allItemList: [],
            completedItemList: [],//已完成的条目
            foreverIgnoreItemList: [],//永久忽略的条目
            incorrectItemList: [],//错误的条目
            nextIgnoreItemList: [],//下次循环忽略的条目
            remainingItemList: [],//未完成的条目

            completedItemIds: [],//已完成的条目
            foreverIgnoreItemIds: [],//永久忽略的条目
            incorrectItemIds: [],//错误的条目
            foreverIgnoreItemIds: [],//下次循环忽略的条目
            historyList: [],
            preIncorrectItemList: [],
            hiddenQuestionVisible: false,
            currentItem: undefined,
            mulAnswer: {},
            rightAnswerMap: {},
            mQuestionBankId: undefined,
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        moment,
        recoverMark: async function(i) {
            const item = this.foreverIgnoreItemList[i]
            try {
                await this.$store.dispatch('recoverMark', {
                    uid: this.userInfo.clientid,
                    clientId: this.userInfo.clientid,
                    questionBankId: this.mQuestionBankId,
                    foreverIgnoreItemIds: [item.questionBankItemId],
                });
                this.foreverIgnoreItemIds.splice(i, 1)
                this.foreverIgnoreItemList.splice(i, 1)
                this.foreverIgnoreItemList = [...this.foreverIgnoreItemList]
            } catch(err) {
                this.$message.warning(err)
            }
        },
        showWrongQuestion: async function(data) {
            if(data.incorrectQuantity == 0) {
                return
            }
            this.isShowHistory = false
            this.isShowWrongQuestion = true
            this.showQuestionModal = true
            this.finalQuestionList = data.incorrectItemList
            this.questionList = [...this.finalQuestionList]
            if(!this.allItemList.length && this.currentItem) {
                await this.getQuestionList()
            }
            this.questionIndex = 0
            this.modalTitle = `查看錯題`
        },
        resetRecord: async function() {
            return await this.$store.dispatch('resetLearnRecord', {
                uid: this.userInfo.clientid,
                clientId: this.userInfo.clientid,
                questionBankId: this.questionList[this.questionIndex].questionBankId,
            });
        },
        handleHiddenQuestions: async function(item) {
            this.mQuestionBankId = item.questionBankId
            await this.getQuestionList()
            if(this.foreverIgnoreItemList.length == 0) {
                this.$message.warning('暫無數據')
                return
            }
            this.hiddenQuestionVisible = true
        },
        showLastWrongQuestion: async function(item) {
            this.mQuestionBankId = item.questionBankId
            if(item.completedTimes == 0) {
                this.$message.warning('暫無數據')
                return
            }
            this.loading = true
            const rs = await this.$store.dispatch('queryCompletedLearnRecord', {
                uid: this.userInfo.clientid,
                clientId: this.userInfo.clientid,
                questionBankId: item.questionBankId,
            });
            await this.getQuestionList()
            this.isShowWrongQuestion = true
            this.showQuestionModal = true
            this.questionIndex = 0
            this.modalTitle = `查看錯題`
        },
        showHistory: async function(item) {
            this.mQuestionBankId = item.questionBankId
            if(item.completedTimes == 0) {
                this.$message.warning('暫無數據')
                return
            }
            this.currentItem = item
            this.loading = true
            const rs = await this.$store.dispatch('queryCompletedLearnRecord', {
                uid: this.userInfo.clientid,
                clientId: this.userInfo.clientid,
                questionBankId: item.questionBankId,
            });
            var data = await this.$store.dispatch('queryQuestionBankItems', {
                uid: this.userInfo.clientid,
                clientId: this.userInfo.clientid,
                questionBankId: item.questionBankId,
            });
            this.allQuestionList = data.allItemList

            this.historyList = rs.completedRecordList
            this.isShowHistory = true
            this.loading = false
        },
        onAnswerChanged: function(checkedValues) {
            this.questionList[this.questionIndex].answers = checkedValues
            this.questionList = [...this.questionList]
        },
        startReview: async function(item) {
            this.mQuestionBankId = item.questionBankId
            if(item.total == 0) {
                this.$message.warning('沒有可以複習的題目')
                return
            }
            this.loading = true
            await this.getQuestionList()
            if(this.questionList.length == 0) {
                this.$message.warning('沒有可以複習的題目')
                this.loading = false
                return
            }
            this.questionIndex = this.completedItemList.length
            this.questionList = [...this.questionList]
            if(this.questionIndex  == this.questionList.length) {
                this.questionIndex = this.questionIndex - 1
            }
            if(this.questionIndex == this.questionList.length-1 && (this.completedItemList.length == this.questionList.length)) {
                this.questionIndex = 0
                this.questionList = [...this.questionList.map((v)=>{return {...v, answers: undefined}})]
            }

            if(this.questionIndex > 0) {
                // 回显答案
                const preAnswers = this.$store.getters.preAnswers || {}
                const answerMap = preAnswers[this.mQuestionBankId]
                if(answerMap) {
                    this.questionList.forEach((q,index)=>{
                        if(!q.answers) {
                            q.answers = answerMap[q.questionBankItemId]
                        }
                        if(q.answers && q.type == 3) {
                            const vList = q.answers.split('，')
                            const mapValue = {}
                            vList.forEach((v,i) => {
                                mapValue[`${i+1}`] = v
                            })
                            if(!this.mulAnswer[`${index}`]) {
                                this.$set(this.mulAnswer, `${index}`, mapValue)
                            }
                        }
                    })
                }
                this.questionList = [...this.questionList]
            }

            const rs = await this.$store.dispatch('queryCompletedLearnRecord', {
                uid: this.userInfo.clientid,
                clientId: this.userInfo.clientid,
                questionBankId: item.questionBankId,
            });
            this.historyList = rs.completedRecordList
            let totalTime = 0
            const list = this.historyList || []
            if(list.length) {
                totalTime = list.reduce((v1,v2)=> {
                    const v1Time = moment(v1.completedTime).toDate().getTime() - moment(v1.firstTime).toDate().getTime()
                    const v2Time = moment(v2.completedTime).toDate().getTime() - moment(v2.firstTime).toDate().getTime()
                    return v1Time+v2Time;
                })
            }
            
            this.modalTitle = `複習 - ${item.title} (累計答題時間: ${Math.floor(totalTime/1000)}秒)`
            this.showQuestionModal = true
            this.loading = false
            if(this.completedItemList.length > 0 && this.completedItemList.length < this.questionList.length) {
                setTimeout(() => {
                    this.$confirm({
                        title: '是否從頭開始複習?',
                        okText: "是",
                        centered: true,
                        cancelText: "否",
                        onOk: async ()=> {
                            const rs = await this.resetRecord()
                            this.startReview({'questionBankId': this.mQuestionBankId})
                        },
                        onCancel: async () => {
                        },
                    });
                }, 500);
            }
        },
        loadData: function () { 
            this.$store.dispatch('getMyQuestionList', {
                uid: this.userInfo.clientid,
                clientId: this.userInfo.clientid,
                pageNum: 1,
                pageSize: 20,
            }).then((rs) => { 
                this.loading = false
                this.dataList = rs.list
            })
        },
        toPrev: async function() {
            this.questionIndex --
        },
        toNext: async function() {
            if(this.isShowWrongQuestion == true) {
                if(this.questionIndex < this.questionList.length - 1) {
                    this.questionIndex ++
                }
                return
            }
            const questionItem = this.questionList[this.questionIndex];
            if(questionItem.type == 3) {
                const obj = this.mulAnswer[`${this.questionIndex}`]
                if(Object.keys(obj).length==Object.values(obj).filter((v)=>v).length) {
                    questionItem.answers = Object.values(obj).join('，')
                }
            }
            if(questionItem.isMustAnswer == true) {
                if((!questionItem.answers || !questionItem.answers.length)) {
                    this.$message.warning(questionItem.type != 1 ? '請輸入答案' : '請選擇答案')
                    return
                }
            }
            
            this.loading = true
            await this.saveProgress()
            if(this.rightAnswerMap[this.mQuestionBankId][`${questionItem.questionBankItemId}`] != questionItem.answers) {
                if(this.incorrectItemList.filter((v)=>v.questionBankItemId == questionItem.questionBankItemId).length <= 0) {
                    this.incorrectItemList.push(questionItem)
                }
            }
            if(this.questionIndex == this.questionList.length - 1) {
                this.preIncorrectItemList = JSON.parse(JSON.stringify(this.incorrectItemList))
                await this.completeLearn()
                this.$message.success('操作成功')
                this.loadData()
                this.showQuestionModal = false
                this.mulAnswer = {}
                this.$confirm({
                    content: `總共${this.questionList.length}題，答錯${this.incorrectItemList.length}題，正確${this.questionList.length-this.incorrectItemList.length}題`,
                    onOk: ()=>{
                        this.showQuestionModal = false
                        this.mulAnswer = {}
                    },
                    okText: '确认',
                    cancelText: '查看错题',
                    onCancel: async () => {
                        if(! this.preIncorrectItemList.length) {
                            this.showQuestionModal = false
                            this.mulAnswer = {}
                            return
                        }
                        this.isShowWrongQuestion = true
                        this.showQuestionModal = true
                        this.finalQuestionList = this.preIncorrectItemList
                        this.questionList = [...this.finalQuestionList]
                        this.questionIndex = 0
                        this.modalTitle = `${this.modalTitle} (錯題共${this.questionList.length}題)`
                    },
                });
            }
            if((this.questionIndex + 1) < this.questionList.length) {
                this.questionIndex ++
            }
            this.loading = false
        },
        completeLearn: async function() {
            var rs = await this.$store.dispatch('completeLearn', {
                uid: this.userInfo.clientid,
                clientId: this.userInfo.clientid,
                questionBankId: this.questionList[this.questionIndex].questionBankId,
            });
            const preAnswers = this.$store.getters.preAnswers || {}
            delete preAnswers[this.mQuestionBankId]
            this.$store.dispatch('saveAnswer', preAnswers)
            return rs
        },
        onQuestionModalCancel: function() {
            this.showQuestionModal = false
            this.isShowWrongQuestion = false
            this.questionIndex = 0
            this.questionList = [...this.finalQuestionList]
            this.mulAnswer = {}
            this.loadData()
        },
        getQuestionList: async function() {
            var rs = await this.$store.dispatch('queryQuestionBankItems', {
                uid: this.userInfo.clientid,
                clientId: this.userInfo.clientid,
                questionBankId: this.mQuestionBankId,
            });
            this.completedItemList = rs.completedItemList //已完成的条目
            this.foreverIgnoreItemList = rs.foreverIgnoreItemList //永久忽略的条目
            this.incorrectItemList = rs.incorrectItemList //错误的条目
            this.nextIgnoreItemList = rs.nextIgnoreItemList //下次循环忽略的条目

            this.completedItemIds = rs.completedItemList.map(v=>v.questionBankItemId) //已完成的条目
            this.foreverIgnoreItemIds = rs.foreverIgnoreItemList.map(v=>v.questionBankItemId) //永久忽略的条目
            this.incorrectItemIds = rs.incorrectItemList.map(v=>v.questionBankItemId) //错误的条目
            this.allItemList = rs.allItemList

            this.finalQuestionList = rs.allItemList.filter(v=>this.foreverIgnoreItemIds.indexOf(v.questionBankItemId)==-1)
            if(!this.rightAnswerMap[this.mQuestionBankId]) {
                this.rightAnswerMap[this.mQuestionBankId] = {}
            }
            for(let item of this.finalQuestionList) {
                if(!this.rightAnswerMap[this.mQuestionBankId][`${item.questionBankItemId}`]) {
                    this.rightAnswerMap[this.mQuestionBankId][`${item.questionBankItemId}`] = await this.getRightAnswer(item.questionBankItemId)
                }
            }
            this.questionList = [...this.finalQuestionList]
        },
        saveProgress: async function() {
            const list = this.questionList.filter((v,i)=>i<=this.questionIndex)
            const completedItemIds = list.map(v=>v.questionBankItemId)
            const incorrectItemIds = list.filter(v=>this.rightAnswerMap[this.mQuestionBankId][v.questionBankItemId] != v.answers || (typeof v.answers == 'object' && this.rightAnswerMap[this.mQuestionBankId][v.questionBankItemId] != v.answers.join(','))).map(v=>v.questionBankItemId)

            // TODO 选中的答案保存本地
            const preAnswers = this.$store.getters.preAnswers || {}
            if(!preAnswers[this.mQuestionBankId]) {
                preAnswers[this.mQuestionBankId] = {}
            }
            list.forEach((question)=>{
                preAnswers[this.mQuestionBankId][question.questionBankItemId] = question.answers 
            })

            this.$store.dispatch('saveAnswer', preAnswers)

            return this.$store.dispatch('recordSchedule', {
                uid: this.userInfo.clientid,
                clientId: this.userInfo.clientid,
                questionBankId: this.questionList[this.questionIndex].questionBankId,
                completedItemIds: [...new Set([...this.completedItemIds, ...completedItemIds])],
                incorrectItemIds: [...new Set([...this.incorrectItemIds, ...incorrectItemIds])],
                foreverIgnoreItemIds: this.foreverIgnoreItemIds
            })
        },
        hideQuestion: function() {
            this.loading = true
            const nextIgnoreItemIds = [...new Set([...this.foreverIgnoreItemIds, this.questionList[this.questionIndex].questionBankItemId])]
            this.$store.dispatch('recordSchedule', {
                uid: this.userInfo.clientid,
                clientId: this.userInfo.clientid,
                questionBankId: this.questionList[this.questionIndex].questionBankId,
                completedItemIds: this.completedItemIds,
                incorrectItemIds: this.incorrectItemIds,
                foreverIgnoreItemIds: nextIgnoreItemIds
            }).then(async (rs) => {
                this.loading = false
                if(this.questionList.length == 1 && this.questionIndex == 0) {
                    window.location.reload()
                    return
                }
                this.questionList.splice(this.questionIndex, 1)
                this.finalQuestionList.splice(this.questionIndex, 1)
                this.questionIndex --
                if(this.questionIndex < 0)
                    this.questionIndex = 0
                this.questionList = [...this.questionList]
            })
        },
        getRightAnswer: async function(questionBankItemId) {
            try {
                var result = await this.$store.dispatch('getQuestionAnswer', {
                    uid: this.userInfo.clientid,
                    clientId: this.userInfo.clientid,
                    questionBankItemId: questionBankItemId,
                })
                return result.answer
            } catch (_) {
                return undefined
            }
        },
        switchShowAnswer: function() {
            this.switchOn = !this.switchOn
        },
        mulQuestions: function(index) {
            if(!this.mulAnswer[`${index}`]) {
                this.$set(this.mulAnswer, `${index}`, {})
            }
            if(!this.questionList) return []
            if(this.questionList.length <= index) return []
            const title = this.questionList[index].title || ''
            const list = title.split('_')
            return list
        },
        onMulAnswerChange(e,questionBankItemId,answerIndex) {
            this.mulAnswer[`${questionBankItemId}`][`${answerIndex}`] = e.target.value
        }
    }
};
</script>
<style lang='scss'>

    .hide-question-list {
        position: relative;
        min-height: 300px;
    }

    .hide-question-list .empty {
        position: absolute;
        left: 50%;
        top: 100px;
        transform: translateX(-50%);
    }

    .ant-radio-group,
    .ant-checkbox-group {
        display: flex;
        flex-direction: column;
    }

    .ant-modal-footer {
        padding-top: 66px;
    }
    
    .ant-radio-wrapper,
    .ant-checkbox-group-item {
        margin-bottom: 10px;
    }

    #my-question-card {
        position: relative;
        min-height: 300px;
        width: 100%;
    }

    .history-list {
        overflow-y: scroll;
        max-height: 500px;
    }

    .history-list .title {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 24px;
    }

    .history-list .history-item {
        display: flex;
        flex-direction: column;
        position: relative;
        font-size: 14px;
        box-shadow:0px 2px 8px 0px rgba(232,234,243,1);  
        margin: 8px 2px;      
        border-radius: 8px;
        padding: 22px 18px 30px 20px;
        box-sizing: border-box;
    }

    .history-list .history-item .btn-wrong {
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
        background-color: #02a5ff;
        color: #fff;
        padding: 2px 6px;
        border-radius: 2px;
        cursor: pointer;
    }

    .history-list .history-item .time {
        margin-bottom: 4px;
    }

    .history-list .history-item .time .hint {
        color: #666;
    }

    .history-list .history-item .time .value {
        color: #333;
    }

    .history-list .history-item .desc {
        color: #f5222d;
        font-size: 15px;
    }

    .history-list .history-item .desc .wrong-item {
        margin-right: 4px;
        position: relative;
        padding-right: 12px;
    }

    .history-list .history-item .desc .wrong-item::after{
        content: '、';
        position: absolute;
        right: 0px;
        bottom: -4px;
        
    }

    .history-list .history-item .desc .wrong-item:last-child {
        padding: 0px;
        margin: 0px;
    }

    .history-list .history-item .desc .wrong-item:last-child::after {
        content: '';
    }

    #my-question-card > .card-item {
        position: relative;
        background-color: #fff;
        padding: 0px 12px;
        height: 120px;
        font-size: 13px;
        font-weight: 400;
        color: #666;
        border-radius: 4px;
        box-shadow: 2px 3px 2px #ececec, -1px 0px 2px #e9e7e7;
        margin: 12px 12px 0 20px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
    }

    #my-question-card > .card-item .operation {
        display: flex;
        flex-direction: column;
        position: absolute;
        right: 20px;
        top: 0px;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    #my-question-card > .card-item h2 {
        font-size: 16px;
        color: #333;
        font-weight: 500;
    }

    #my-question-card > .card-item .btn-review {
		text-align: center;
		line-height: 20px;
		font-weight: 300;
		background-color: #02a5ff;
		border-radius: 4px;
		font-weight: 400;
		font-size: 14px;
		cursor: pointer;
        padding: 4px 8px;
        width: 124px;
        color: #fff;
        box-sizing: border-box;
    }

    #my-question-card > .card-item .schedule {
        height: 14px;
        line-height: 14px;
        font-size: 10px;
        text-align: center;
        border-radius: 2px;
        width: 124px;
        background-color: #f5f5f5;
        position: relative;
        margin-top: 2px;
    }

    #my-question-card > .card-item .schedule > .v-schedule {
        width: 1%;
        height: 14px;
        border-top-left-radius: 2px;
        border-bottom-left-radius: 2px;
        background-color: #52c41a;
        position: absolute;
    }

    #my-question-card > .card-item .schedule > .v-schedule.full {
        border-top-right-radius: 2px;
        border-bottom-right-radius: 2px;
    }

    #my-question-card > .card-item .complted-count {
        margin-top: 8px;
        text-decoration: underline;
    }

    #my-question-card > .card-item .schedule > span {
        position: relative;
        z-index: inherit;
        color: #666;
    }
    
    .question-container {
        position: relative;
        height: 40vh;
        width: 100%;
    }

   .question-container .question-item {
        background-color: #fff;
        margin-bottom: 12px;
    }

    .question-container .question-title {
        font-size: 17px;
        font-weight: bold;
        color: #151515;
        line-height: 32px;
        margin-bottom: 10px;
        display: flex;
        flex-wrap: wrap;
    }

    .question-container .question-title .question-title-item {
        display: inline-block;
    }

    .question-container .question-title .input-container {
        display: inline-block;
        width: 84px;
        text-decoration: underline;
        margin: 0px 8px;
        padding: 0px 4px;
        box-sizing: border-box;
        border-bottom: 1px solid #333;
        font-size: 18px;
        font-weight: 400;
        color: #666;
    }

    .question-container .question-title .input-container input {
        width: 100%;
    }

    .question-container .question-answer {
        font-size: 14px;
        font-weight: normal;
        color: #666;
        line-height: 32px;
    }

    .question-container .question-input-answer {
        font-size: 14px;
        font-weight: normal;
        color: #333;
        line-height: 32px;
        width: calc(100% - 16px);
        border-radius: 2px;
        padding: 0px 12px;
        box-sizing: border-box;
        margin: 0px 8px;
        border: 1px solid #f1f1f1;
    }

    .footer-items {
        position: absolute;
        left: 20px;
        bottom: 50px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .footer-items > .footer-item {
        margin-right: 24px;
    }

    .footer-items > a.footer-item {
        text-decoration: underline;
    }

    .footer-items > .footer-item.switch {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
        user-select: none;
        width: 90px;
    }

    .footer-items > .footer-item .icon {
        display: inline-block;
        height: 21px;
        width: 36px;
        background-image: url(../../assets/imgs/switch_on.png);
        background-size: 100% 100%;
        margin-bottom: 2px;
    }

    .footer-items > .footer-item .icon.off {
        background-image: url(../../assets/imgs/switch_off.png);
    }

    .right-answer {
        font-size: 15px;
        font-weight: 500;
        color: #f5222d;
    }

    .hide-question-item {
        display: flex;
        flex-direction: row;
        height: 50px;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #f3f3f3;
        padding: 0px 8px;
        box-sizing: border-box;
    }

    .hide-question-item .btn-delete {
        height: 24px;
        line-height: 20px;
        background-color: #02a5ff;
        color: #fff;
        padding: 2px 24px;
        border-radius: 2px;
        cursor: pointer;
    }
</style>